import { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getStepsByGoal, setFirstLogin } from "../redux/actions";
import styled from "styled-components";
import theme from "../theme/theme";
import Header from "../components/Header";
import GoalContainer from "../components/GoalContainer";
import LoadingBar from "../components/LoadingBar/LoadingBar";
import { SET_LOADING } from "../redux/action-types";
import { analytics } from "../analytics";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px;

  h1 {
    color: ${theme.colors.primaryStrong};
    text-align: center;
    font-weight: 500;
    margin-bottom: 55px;
  }

  .goalsWrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 25px;
  }

  @media (max-width: 1075px) {
    padding: 5%;
  }
`;

const GoalPicker = () => {
  const dispatch = useDispatch();
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  const history = useHistory();
  const { loading, userAccountDetails, isFirstLogin, setGoalToLaunchDetails } =
    useSelector((state) => state.user);
  const [isLoaded, setIsLoaded] = useState(true);

  useEffect(() => {
    if (loading) {
      setIsLoaded(false);
    }
  }, [loading]);

  useEffect(() => {
    if (userAccountDetails) {
      dispatch({ type: SET_LOADING, payload: false });
    }
  }, [dispatch, userAccountDetails]);

  useEffect(() => {
    dispatch(setFirstLogin(false));
  }, [dispatch]);

  const handleClick = useCallback(
    ({ target }) => {
      target.classList.add("loading");
      setButtonsDisabled(true);
      dispatch({ type: SET_LOADING, payload: true });
      dispatch(
        getStepsByGoal({
          type: target.dataset.goalType,
          path: target.dataset.goalPath,
        })
      ).then((data) => {
        const date = new Date().toLocaleString();
        analytics.track("Goal Created", {
          goalId: data?.goalId || "",
          goalType: target?.dataset?.goalType || "",
        });
        analytics.track("Questionnaire Started", {
          goalId: data?.goalId || "",
          goalType: target?.dataset?.goalType || "",
          questionnaireStarted: date,
        });
        history.push(target.dataset.goalPath);
      });
    },
    [dispatch, history]
  );

  return (
    <>
      {(!isLoaded || loading) && (
        <LoadingBar isLoading={loading} setIsLoaded={setIsLoaded} />
      )}
      <Header />
      <Wrapper>
        <h1>Select a Goal</h1>
        <div className="goalsWrapper">
          <GoalContainer
            path="/build_wealth"
            type="Build Wealth"
            desc="Keep your savings on track and grow for the future."
            disabled={buttonsDisabled}
            handleClick={handleClick}
          />
          <GoalContainer
            path="/major_purchase"
            type="Major Purchase"
            desc="From buying a home to a trip to outerspace, the first step to achieving a goal is setting one."
            disabled={buttonsDisabled}
            handleClick={handleClick}
          />
          <GoalContainer
            path="/education"
            type="Education"
            desc="If knowledge is power, saving now is smart."
            disabled={buttonsDisabled}
            handleClick={handleClick}
          />
          <GoalContainer
            path="/retirement"
            type="Retirement"
            desc="Start investing now so you can reach the stars later."
            disabled={buttonsDisabled}
            handleClick={handleClick}
          />
        </div>
      </Wrapper>
    </>
  );
};

export default GoalPicker;
